import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import carpet from './Component/product/carpet.jpeg';
import hardwood from './Component/product/hardwood.png';
import glasstile from './Component/product/glasstile.png';
import laminate from './Component/product/laminate.png';
import luxuryvinyl from './Component/product/luxuryvinyl.png';
import Tile from './Component/product/Tile.png';
import vinyl from './Component/product/vinyl.png';
import waterproof from './Component/product/waterproof.png';
import { useNavigate } from 'react-router-dom';
import s2 from './Component/s2.png';

const products = [
  {
    id: 'carpet',
    label: 'Carpet',
    img: carpet,
    alt: 'Shop for carpet at Nickle\'s Flooring in Cassville, MO',
  },
  {
    id: 'hardwood',
    label: 'Hardwood',
    img: hardwood,
    alt: 'Shop for hardwood flooring at Nickle\'s Flooring',
  },
  {
    id: 'metaltile',
    label: 'Metal Tile',
    img: laminate,
    alt: 'Shop for metal tile at Nickle\'s Flooring',
  },
  {
    id: 'Tile',
    label: 'Tile',
    img: Tile,
    alt: 'Shop for tile flooring at Nickle\'s Flooring',
  },
  {
    id: 'luxuryvinyl',
    label: 'Luxury Vinyl',
    img: luxuryvinyl,
    alt: 'Shop for luxury vinyl at Nickle\'s Flooring',
  },
  {
    id: 'naturalstone',
    label: 'Natural Stone',
    img: waterproof,
    alt: 'Shop for natural stone at Nickle\'s Flooring',
  },
  {
    id: 'vinyl',
    label: 'Vinyl',
    img: vinyl,
    alt: 'Shop for vinyl flooring at Nickle\'s Flooring',
  },
  {
    id: 'glasstile',
    label: 'Glass Tile',
    img: glasstile,
    alt: 'Shop for glass tile at Nickle\'s Flooring',
  },
];

function Product() {
  const navigate = useNavigate();

  const handlepropertyselect = (id) => {
    navigate(`/products/${id}`);
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <Headers />

      <section className="bg-[#803333] text-white py-10 md:py-14">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-2xl md:text-4xl font-bold tracking-tight mb-2">
            Shopping for new floors in the Cassville, MO area?
          </h1>
          <p className="text-white/85 text-sm md:text-base max-w-2xl mx-auto m-0">
            Browse the most extensive local online flooring catalog
          </p>
        </div>
      </section>

      <section className="container mx-auto px-4 py-10 md:py-14">
        <div className="row g-4">
          {products.map((product) => (
            <div key={product.id} className="col-6 col-md-3">
              <button
                type="button"
                onClick={() => handlepropertyselect(product.id)}
                className="group w-100 h-100 bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden text-start p-0 transition-all hover:-translate-y-1 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#803333]/30"
              >
                <div className="aspect-square overflow-hidden bg-gray-100">
                  <img
                    src={product.img}
                    alt={product.alt}
                    title={product.alt}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="p-3 md:p-4 flex items-center justify-between gap-2">
                  <span className="font-semibold text-[#803333] text-sm md:text-base">
                    {product.label}
                  </span>
                  <i className="bi bi-arrow-right text-[#803333] opacity-0 -translate-x-1 transition-all group-hover:opacity-100 group-hover:translate-x-0" />
                </div>
              </button>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14">
          <a
            href="/financing"
            className="block overflow-hidden rounded-xl shadow-sm hover:shadow-md transition-shadow"
          >
            <img
              src={s2}
              alt="Explore financing options at Nickle's Flooring"
              className="w-full h-auto d-block"
            />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Product;
